import { store, store$ } from '@redux/store';
import { searchParametersActions, activeAdultCommunitiesSelector } from 'features/searchResultsFacets';
import { distinctUntilChanged, fromEvent, map } from 'rxjs';
import ActiveAdultType from '../enums/activeAdultType';

/**
 * The container element for the active adult filter.
 */
const container = document.querySelector('[data-active-adults]');

/**
 * Observable that emits when the 'change' event is triggered on the 'container' element.
 * The emitted value is then used to determine which action to dispatch.
 * @type {Observable<Event>}
 */
const activeAdult$ = fromEvent(container, 'change');

/**
 * Handles the change event for the active adult filter.
 * @param {Object} event - The event object.
 */
function handleActiveAdultChange ({ target }) {
    const { value, checked } = target;
    
    switch (value) {
        case ActiveAdultType.OnlyShowActiveAdultCommunities.toString():
            store.dispatch(searchParametersActions.fetchActiveAdult(checked));
            break;
        case ActiveAdultType.ExcludeActiveAdultCommunities.toString():
            store.dispatch(searchParametersActions.fetchExcludeActiveAdult(checked));
            break;
        case ActiveAdultType.AnyCommunities.toString():
            store.dispatch(searchParametersActions.fetchAnyCommunities());
            break;
        default:
            break;
    }
}

activeAdult$.subscribe(handleActiveAdultChange);

/**
 * Updates the active adult filters based on the redux store values.
 * @param {Object} filters - The filters object containing the filter names and their corresponding boolean values.
 */
function updateActiveAdultFilters(filters) {
    const filterNames = Object.keys(filters);

    filterNames.forEach((filter) => {
        const radio = container.querySelector(`[value="${filter}"]`);
        radio.checked = filters[filter];
    });
}

/**
 * Subscribes to the store to update the active adult filters when the store values change.
 * uses the 'activeAdultCommunitiesSelector' selector to get the active adult filters values from the store.
 */
store$
  .pipe(
    map(activeAdultCommunitiesSelector),
    distinctUntilChanged()
  )
  .subscribe(updateActiveAdultFilters);
